<template>
  <div
    id="app"
    v-loading.fullscreen.lock="this.$store.state.loader"
  >
    <router-view />
  </div>
</template>

<script>

  export default {
    name: "QasedakWebConsole",

    data() {
      return {
      }
    },

    computed: {},

    created() {
    },

    mounted() {
      document.body.style.direction = this.$qt('direction');
    },

    methods: {}
  };

</script>

<style scoped>
</style>
